import AutoSuggest from './AutoSuggest';

export default AutoSuggest;
